import { forwardRef, useImperativeHandle } from 'react'
import { Typography } from '@mui/material'

import { Stack, Text } from '../../../components'

export const OTHER_PAYMENT_METHODS = [
  'estate-gifts',
  'crypto-currency',
  'flow-through-shares',
  'insurance-gifts',
  'shares-of-private-corporations',
]

export async function getPaymentValues({ values }) {
  return {
    paymentMethodType: values.paymentMethodType,
    selectedGivingOptions: [values.paymentMethodType],
  }
}

export const getPaymentMethodDisplayName = (paymentMethod) => {
  const displayNames = {
    'estate-gifts': 'Estate Gifts',
    'crypto-currency': 'Cryptocurrency',
    'flow-through-shares': 'Flow-Through Shares',
    'insurance-gifts': 'Insurance Gifts',
    'shares-of-private-corporations': 'Private Corporation Shares',
  }
  return displayNames[paymentMethod] || paymentMethod
}

export const PaymentUI = forwardRef(({ paymentType = 'this giving method' }, ref) => {
  useImperativeHandle(ref, () => ({}))

  return (
    <Stack spacing={2}>
      <Typography variant="h6">Request Information for {paymentType}</Typography>
      <Text.Body>
        Our team will reach out to you with detailed information about donating through {paymentType}. This specialized
        giving method may offer unique tax advantages and impact opportunities.
      </Text.Body>
    </Stack>
  )
})
